// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 71) return "static/chunks/71-2e971340e2a83f88.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"616":"1dae32a69a1ffee3","1190":"ea9d3d2bba589a95","1396":"c7c93dc048f6f6c3","3173":"9f0347654a96594b","9741":"450408645b13d68f"}[chunkId] + ".js";
};